import { z } from 'zod'
import { backtestInstrumentSchema } from './backtest-config.schema'

// ticker/name captured at save time so a loaded set can render labels without a
// round-trip to resolve every uid
export const backtestInstrumentSetLabelSchema = z.object({
  instrumentUid: z.string(),
  ticker: z.string().optional(),
  name: z.string().optional(),
})

export type BacktestInstrumentSetLabelDto = z.infer<typeof backtestInstrumentSetLabelSchema>

export const createBacktestInstrumentSetSchema = z.object({
  name: z.string().min(1).max(60),
  // instruments may or may not carry per-instrument overrides (the user chooses
  // whether to save overrides via a checkbox)
  instruments: z.array(backtestInstrumentSchema).min(1).max(50),
  labels: z.array(backtestInstrumentSetLabelSchema),
})

export type CreateBacktestInstrumentSetDto = z.infer<typeof createBacktestInstrumentSetSchema>

export const backtestInstrumentSetSchema = createBacktestInstrumentSetSchema.extend({
  id: z.string(),
  createdAt: z.coerce.date(),
})

export type BacktestInstrumentSetDto = z.infer<typeof backtestInstrumentSetSchema>
